var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagramBlack = function SvgInstagramBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#instagram-black_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-1.667a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.167a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.378 3.563c-.545 1.07-.545 2.47-.545 5.27v2.334c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185c1.07.545 2.47.545 5.27.545h2.334c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185c.545-1.07.545-2.47.545-5.27V8.833c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185c-1.07-.545-2.47-.545-5.27-.545H8.833c-2.8 0-4.2 0-5.27.545a5 5 0 0 0-2.185 2.185M11.167 2.5H8.833c-1.427 0-2.398.001-3.148.063-.73.06-1.104.167-1.365.3-.627.32-1.137.83-1.457 1.457-.133.26-.24.634-.3 1.365-.062.75-.063 1.72-.063 3.148v2.334c0 1.427.001 2.398.063 3.148.06.73.167 1.104.3 1.365.32.627.83 1.137 1.457 1.457.26.133.634.24 1.365.3.75.062 1.72.063 3.148.063h2.334c1.427 0 2.398-.001 3.148-.063.73-.06 1.104-.168 1.365-.3a3.33 3.33 0 0 0 1.457-1.457c.133-.26.24-.634.3-1.365.062-.75.063-1.72.063-3.148V8.833c0-1.427-.001-2.398-.063-3.148-.06-.73-.168-1.104-.3-1.365a3.33 3.33 0 0 0-1.457-1.457c-.26-.133-.634-.24-1.365-.3-.75-.062-1.72-.063-3.148-.063",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram-black_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgInstagramBlack;